import React from 'react'
import { Container, Button, Row, Col, Input } from 'reactstrap';
import * as XLSX from "xlsx";
import 'bootstrap/dist/css/bootstrap.css';

//const testData = require('./TestData.js');

class ImportReconReports extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            clientAccountNumber: 0,
            clientName: '',
            clientId: 0,
            date: null,
            importData: [],
            reconReports: [],
            readSuccess: false,
            uploadSuccess: false,
            saveSuccess: false,
            newReconcile: 0,
            newUnreconcile: 0
        };

    }

    componentDidMount = () => {
        this.props.log('ImportReconReports.js/componentDidMount');
        this.getReconReports();
    }

    getClientName = (accountNumber) => {
        this.props.log('ImportReconReports.js/getClientName (accountNumber)', accountNumber);
        if (accountNumber === '' || parseInt(accountNumber) === 0 || isNaN(parseInt(accountNumber))) return '';
        const arr = this.props.clients.filter(client => parseInt(client.customerNumber) === parseInt(accountNumber))
        if (arr[0] != null) return arr[0];
    }

    getReconReports = () => {
        this.props.log('ImportReconReports.js/getReconReports');
        fetch('/api/reconReports/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        }).then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        reconReports: results.data
                    })
                } else {
                    this.props.addToast('Unable to load recon reports.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleUpload = (e, schema) => {
        this.props.log('ImportReconReports.js/handleUpload (e,schema) ', e, schema);
        e.preventDefault();
        var files = e.target.files, f = files[0];
        // console.log(fileId, 'fileId')
        var reader = new FileReader();
        let newReconcile = 0, newUnreconcile = 0;
        reader.onload = (r) => {
            var result = r.target.result;
            let readedData = XLSX.read(result, { type: 'binary', cellDates: true, sheetStubs: true });
            let tabData = [];
            readedData.SheetNames.forEach(sheet => {
                const ws = readedData.Sheets[sheet];
                /* Convert array to json*/
                let data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                const numColumns = Math.max(...data.map(el => el.length));
                if (data.length === 0) return;
                let trimBlankRowPos = -1;
                data.forEach((row, index, arr) => {
                    let newArr = new Array(numColumns).fill('');
                    const x = newArr.map((el, i) => (row[i] != null) ? row[i].toString() : '');
                    arr[index] = x;
                    if (row.every(cell => cell === '') && trimBlankRowPos === -1) {
                        trimBlankRowPos = index;
                    } else if (!(row.every(cell => cell === ''))) {
                        trimBlankRowPos = -1;
                    }
                })
                if (trimBlankRowPos > -1) data.splice(trimBlankRowPos);
                tabData.push({ tab: sheet, data: data });
            })
            tabData.forEach(tab => {
                tab.data.splice(0, 1);
            })
            let data = [];
            tabData[0].data.forEach((row, rowIndex) => {
                let dataRow = [new Date(tabData[0].data[2][0])];
                dataRow[8] = 'n';
                if (row[0] === 'Portfolio ') {
                    dataRow[1] = row[1];
                    dataRow[9] = row[0] + row[1] + ' ' + row[2] + ' ' + tabData[0].data[rowIndex + 1][0];
                    data.push(dataRow);
                } else if (row[0] === '' || row[3] === '' || row[0].substr(0, 3) === '---' || row[0] === 'Portfolio') {
                } else if (row[0].substr(0, 16) === 'TOTAL Reconciled') {
                    newReconcile = parseInt(row[3]);
                } else if (row[0].substr(0, 18) === 'TOTAL Unreconciled') {
                    newUnreconcile = parseInt(row[3]);
                } else if (row[0].substr(0, 16) === 'TOTAL Portfolios') {
                } else {
                    row.forEach((col, colIndex) => {
                        if (colIndex < 7) dataRow[colIndex + 1] = col;
                    })
                    data.push(dataRow);
                }
            })
            // console.log('tabData', tabData[0].data)
            // console.log('tabData', data)
            this.setState({
                uploadSuccess: false,
                saveSuccess: false,
                importData: data,
                newReconcile: newReconcile,
                newUnreconcile: newUnreconcile
            });
        };
        if (f instanceof Blob || typeof (f) === 'object') {
            // reader.readAsBinaryString(f)
            let name = f.name.match(/\s([0-9]{4})\s/);
            let date = f.name.match(/\s([0-9]{6})-Recon_/);
            if (name != null && name.length > 0 && name[1] != null) {
                this.setState({
                    readSuccess: true,
                    clientAccountNumber: parseInt(name[1]),
                    clientName: this.getClientName(name[1]).client,
                    clientId: this.getClientName(name[1]).id,
                    date: new Date('20' + date[1].substr(4, 2), parseInt(date[1].substr(0, 2)) - 1, parseInt(date[1].substr(2, 2)))
                }, () => reader.readAsBinaryString(f));
            } else {
                this.setState({
                    readSuccess: true
                }, () => reader.readAsBinaryString(f));
            }
        } else {
            this.setState({
                uploadSuccess: false,
                saveSuccess: false,
                importData: [],
            })
        }

    }

    handleSave = () => {
        this.props.log('ImportReconReports.js/handleSave');
        const json_request = JSON.stringify({
            clientId: this.state.clientId,
            date: this.state.date,
            reconciled: 0,
            reconciliations: this.state.importData,
            newReconcile: this.state.newReconcile,
            newUnreconcile: 0
        });
        fetch('/api/reconReports/', {
            method: 'POST',
            body: json_request,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        }).then(results => results.json())
            .then(results => {
                results.success ?
                    this.setState({
                        uploadSuccess: true,
                        saveSuccess: true,
                        importData: [],
                        newReconcile: 0,
                        newUnreconcile: 0,
                        clientId: 0,
                        clientName: '',
                        clientAccountNumber: 0,
                        date: null,
                        readSuccess: false
                    }, () => { this.getReconReports(); this.props.addToast('Recon reports imported successfully.', 5, 'success') }) :
                    this.setState({
                        uploadSuccess: true,
                        saveSuccess: false,
                    }, () => this.props.addToast('Unable to import recon report.', 5, 'danger'))
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    };

    handleDelete = (year, month, date) => {
        this.props.log('ImportReconReports.js/handleDelete');
        fetch('/api/reconReports/' + year + '/' + month + '/' + date, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        }).then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getReconReports();
                    this.props.addToast('Recon report deleted successfully.', 5, 'success');
                } else {
                    this.props.addToast('Unable to delete recon report.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    };

    render = () => {
        this.props.info('ImportReconReports.js/render');
        return (
            <>
                <Container>
                    {/* {this.state.uploadSuccess ?
                        <Row><Col md={12}> {(this.state.saveSuccess ?
                            <Alert color="success">Upload successful.</Alert> :
                            <Alert color="danger">Upload unsuccessful.</Alert>)}
                        </Col></Row>
                        : <></>} */}
                    <Row>
                        <Col md={6}>
                            <Row className="p-2">
                                <Col md={12} className="text-left">
                                    <Input type="file" name={"file_"} id="file" accept='.xlsx,.xls' onChange={e => this.handleUpload(e)} />
                                </Col>
                            </Row>
                            <Row className="p-2">
                                <Col md={12} className="text-left">
                                    <Button color="success" disabled={this.state.importData.length === 0} onClick={this.handleSave} title="Upload">Upload</Button>
                                </Col>
                            </Row>
                        </Col>
                        {(this.state.importData.length > 0) ?
                            <Col md={6}>
                                <Row className="p-2">
                                    <Col md={12}>
                                        {this.state.importData.length} records ready to upload
                                    </Col>
                                </Row>
                            </Col> : <></>}
                    </Row>
                    {/* <hr />
                    <Row className="text-left">
                        <Col>Imported files / records per date:</Col>
                    </Row>
                    <Row className="text-left">
                        <Col>
                            {this.state.reconReports.map(data => (
                                <span className="px-3 py-5 timerLine"><strong>{data.date}</strong> <em>({data.count})</em>
                                    <Button color="danger" className="widthButtonIcon"
                                        onClick={() => this.handleDelete(data.year, data.month, data.day)}>
                                        <FontAwesomeIcon icon={faTimes} />
                                    </Button>
                                </span>
                            ))}
                        </Col>
                    </Row> */}
                </Container>
            </>
        )
    }
}

export default ImportReconReports;